import React, { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

mapboxgl.accessToken =
  "pk.eyJ1IjoiYWJoaWppdGgxMjc5IiwiYSI6ImNtNGNqdzE4NDA2MGoyaXFwdXh6cjVqMWQifQ.OpRKi-Zt3NIOjXFz-hd-DA";

const FemaComponent = () => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  const FLOOD_ZONE_LEGEND = [
 
  { zone: "X", color: "#4CAF50", label: "X - Minimal Risk" },
  { zone: "AE", color: "#FF9800", label: "AE - High Risk + BFE" },
  { zone: "VE", color: "#E91E63", label: "VE - Coastal + BFE" },
  { zone: "A", color: "#2196F3", label: "A - High Risk (No BFE)" },
  { zone: "null", color: "#9fa2e7", label: "Unknown" },
 
 
 
];
  useEffect(() => {
    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/light-v11",
      center: [-82.5929, 28.8917],
      zoom: 10,
    });

    mapRef.current.on("load", async () => {
      try {
        console.log("Fetching GeoJSON...");
        const res = await fetch("/assets/parcel/Fema_Flood_Parcel_Custom.geojson");
        //const res = await fetch("/assets/parcel/matched_fema_intersect.geojson");
        const geojson = await res.json();

        console.log("GeoJSON loaded:", geojson);

        // Add source
        mapRef.current.addSource("parcels", {
          type: "geojson",
          data: geojson,
        });


        mapRef.current.addLayer({
          id: "parcel-fill",
          type: "fill",
          source: "parcels",
          paint: {
            "fill-color": [
              "match",
              ["get", "parcel_custom_fema_flood"], // property from GeoJSON
              "X", "#4CAF50",
              "AE", "#FF9800",
              "VE", "#E91E63",
              "A", "#2196F3",
      /* default */ "#9fa2e7"
            ],
            "fill-opacity": 0.45,
          },
        });
        mapRef.current.addLayer({
          id: "parcel-outline",
          type: "line",
          source: "parcels",
          paint: {
            "line-color":  [
              "match",
              ["get", "parcel_custom_fema_flood"], // property from GeoJSON
              "X", "#4CAF50",
              "AE", "#FF9800",
              "VE", "#E91E63",
              "A", "#2196F3",
      /* default */ "#9fa2e7"
            ],
            // "line-color": colorExpr,
            "line-width": 1.3,
          },
        });

      } catch (error) {
        console.error("Error while loading or adding layers:", error);
      }
    });

    return () => mapRef.current.remove();
  }, []);

  return (
    <>
    <div
      ref={mapContainerRef}
      style={{ width: "100%", height: "100vh" }}
    />
    {/*FLOOD ZONE LEGEND - Bottom Center */}
    <div
      style={{
        position: "absolute",
        bottom: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "rgba(255, 255, 255, 0.95)",
        padding: "5px 5px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25)",
        fontFamily: "Inter, sans-serif",
        fontSize: "12px",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <span
        style={{
          fontWeight: "600",
          color: "#333",
          fontSize: "13px",
          marginRight: "5px",
        }}
      >
        FloodZone:
      </span>
      {FLOOD_ZONE_LEGEND.map((item) => (
        <div
          key={item.zone}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <div
            style={{
              width: "18px",
              height: "18px",
              backgroundColor: item.color,
               opacity:0.50,
              borderRadius: "3px",
                 border: `2px solid ${item.color}`, 
            }}
          />
          <span style={{ color: "#555", fontSize: "11px", whiteSpace: "nowrap" }}>
            {item.label}
          </span>
        </div>
      ))}
    </div>
    </>
  );
};

export default FemaComponent;
